import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { useAuth } from "../context/AuthProvider";
import logoutIcon from "../assets/images/logout.svg";
import logo from "../assets/logo.png";
import collapse from "../assets/images/collapse.svg";
import dashboard from "../assets/images/dashboard.svg";
import setting from "../assets/images/setting.svg";
//import search from "../assets/images/search.svg";
import usersInactive from "../assets/images/users-inactive.svg";
import usersActive from "../assets/images/users-active.svg";
import arrowDown from "../assets/images/arrow-down.svg";
import arrowUp from "../assets/images/arrow-up.svg";
import clock from "../assets/images/clock.svg";
import history from "../assets/images/history.svg";


// Iconițele pentru submeniul Terapeuți
import teamIcon from "../assets/images/users-inactive.svg";
//import statsIcon from "../assets/images/chart.svg";
import appointmentsIcon from "../assets/images/calendar.svg";
import bonusIcon from "../assets/images/wallet.svg";
import medicIcon from "../assets/images/medic.svg";
import listIcon from "../assets/images/list.svg";

interface WebmasterSidebarProps {
  onCollapseChange?: (collapsed: boolean) => void;
}

const WebmasterSidebar: React.FC<WebmasterSidebarProps> = ({ onCollapseChange }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { logout } = useAuth();

  // Starea collapsed gestionată intern (inițial din localStorage)
  const [isCollapsed, setIsCollapsed] = useState<boolean>(() => {
    return localStorage.getItem("sidebarCollapsed") === "true";
  });

  // Stare pentru submeniu
  const [openSubmenu, setOpenSubmenu] = useState<string | null>(null);
  const [openSubmenuS, setOpenSubmenuS] = useState<string | null>(null);

  useEffect(() => {
    if (location.pathname.startsWith("/webmaster/therapists")) {
      setOpenSubmenu("therapists");
    } else {
      setOpenSubmenu(null);
    }
  }, [location]);

    useEffect(() => {
    if (location.pathname.startsWith("/webmaster/settings")) {
      setOpenSubmenuS("settings");
    } else {
      setOpenSubmenuS(null);
    }
  }, [location]);

  const toggleSubmenuS = (menuName: string) => {
    setOpenSubmenuS((prev) => (prev === menuName ? null : menuName));
  };

    const toggleSubmenu = (menuName: string) => {
    setOpenSubmenu((prev) => (prev === menuName ? null : menuName));
  };

  // Toggle pentru collapse: actualizează starea internă și notifică părintelui
  const handleToggle = () => {
    const newState = !isCollapsed;
    setIsCollapsed(newState);
    localStorage.setItem("sidebarCollapsed", newState.toString());
    if (onCollapseChange) {
      onCollapseChange(newState);
    }
  };

  const handleLogout = () => {
      Swal.fire({
        title: "Sigur dorești să ieși din cont?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Da",
        cancelButtonText: "Anulează",
        confirmButtonColor: "#6C298B",
        cancelButtonColor: "#dc3545",
      }).then((result) => {
        if (result.isConfirmed) {
          logout(); // aceasta funcție ar trebui să șteargă token-ul și userul
          navigate("/login");
        }
      });
  };

  return (
    <div className={`webmaster-sidebar ${isCollapsed ? "collapsed" : ""}`}>
      {/* Header Sidebar: logo + buton collapse */}
      <div className="sidebar-header">
        {!isCollapsed && (
          <img src={logo} alt="Logo" className="sidebar-logo" />
        )}
        <button className="collapse-btn" onClick={handleToggle}>
          <img src={collapse} alt="collapse" className="icon-collapse" />
        </button>
      </div>

      <ul className="sidebar-menu">
        {/* Dashboard */}
        <li className={location.pathname === "/webmaster/dashboard" ? "active" : ""}>
          <Link to="/webmaster/dashboard">
            <img src={dashboard} alt="dashboard" />
            {!isCollapsed && <span className="text">Dashboard</span>}
          </Link>
        </li>

                {/* Meniul Terapeuți */}
        {isCollapsed ? (
          <>
          <li className={location.pathname.startsWith("/webmaster/settings/types") ? "active" : ""}>
              <Link to="/webmaster/settings/types-settings">
                <img src={setting} alt="setări" />
                {!isCollapsed && <span className="text">Tipuri date</span>}
              </Link>
            </li>
            <li className={location.pathname.startsWith("/webmaster/settings/work") ? "active" : ""}>
                <Link to="/webmaster/settings/work-schedule">
                  <img src={clock} alt="setări" />
                  {!isCollapsed && <span className="text">Program terapeuți</span>}
                </Link>
              </li>
              <li className={location.pathname.startsWith("/webmaster/settings/medic-work") ? "active" : ""}>
                <Link to="/webmaster/settings/medic-work-schedule">
                  <img src={clock} alt="setări" />
                  {!isCollapsed && <span className="text">Program medici</span>}
                </Link>
              </li>
            <li className={location.pathname.startsWith("/webmaster/settings/appointments-history") ? "active" : ""}>
                <Link to="/webmaster/settings/appointments-history">
                  <img src={history} alt="setări" />
                  {!isCollapsed && <span className="text">Istoric programări</span>}
                </Link>
              </li>

          </>
        ) : (
          <li
            className={`has-submenu settings-submenu ${
              openSubmenuS === "settings" ? "open" : ""
            } ${
              location.pathname.startsWith("/webmaster/settings") ? "active" : ""
            }`}
          >
            <div className="submenu-toggle" onClick={() => toggleSubmenuS("settings")}>
              <img
                src={
                  location.pathname.startsWith("/webmaster/settings") || openSubmenuS === "settings"
                    ? setting
                    : setting
                }
                alt="settings"
                className="setting-image"
              />
              <>
                <span className="text">Setări</span>
                <img
                  src={
                    location.pathname.startsWith("/webmaster/settings") || openSubmenuS === "settings"
                      ? arrowUp
                      : arrowDown
                  }
                  alt="arrow"
                  className={`arrow-icon ${openSubmenuS === "settings" ? "rotated" : ""}`}
                />
              </>
            </div>
            {openSubmenuS === "settings" && (
              <ul className="submenu">
                <li className={location.pathname === "/webmaster/settings/types-settings" ? "active-sub" : ""}>
                  <Link to="/webmaster/settings/types-settings">Tipuri date</Link>
                </li>
                <li className={location.pathname === "/webmaster/settings/work-schedule" ? "active-sub" : ""}>
                  <Link to="/webmaster/settings/work-schedule">Program terapeuți</Link>
                </li>
                <li className={location.pathname === "/webmaster/settings/medic-work-schedule" ? "active-sub" : ""}>
                  <Link to="/webmaster/settings/medic-work-schedule">Program medici</Link>
                </li>
                <li className={location.pathname === "/webmaster/settings/appointments-history" ? "active-sub" : ""}>
                  <Link to="/webmaster/settings/appointments-history">Istoric programări</Link>
                </li>
               
              </ul>
            )}
          </li>
        )}



        {/* Titlu secțiune */}
        {!isCollapsed && <li className="menu-title">Meniu</li>}

        {/* Meniul Terapeuți */}
        {isCollapsed ? (
          <>
            <li className={location.pathname === "/webmaster/therapists" ? "active" : ""}>
              <Link to="/webmaster/therapists">
                <img src={teamIcon} alt="Echipă" />
              </Link>
            </li>
            <li className={location.pathname === "/webmaster/therapists/appointments" ? "active" : ""}>
              <Link to="/webmaster/therapists/appointments">
                <img src={appointmentsIcon} alt="Programări" />
              </Link>
            </li>
            <li className={location.pathname === "/webmaster/therapists/scores" ? "active" : ""}>
              <Link to="/webmaster/therapists/scores">
                <img src={listIcon} alt="Punctaje" />
              </Link>
            </li>
            <li className={location.pathname === "/webmaster/therapists/medic-scores" ? "active" : ""}>
              <Link to="/webmaster/therapists/medic-scores">
                <img src={listIcon} alt="Acoperire orară medici" />
              </Link>
            </li>
            <li className={location.pathname === "/webmaster/therapists/points" ? "active" : ""}>
              <Link to="/webmaster/therapists/points">
                <img src={bonusIcon} alt="Puncte bonus" />
              </Link>
            </li>
          </>
        ) : (
          <li
            className={`has-submenu ${
              openSubmenu === "therapists" ? "open" : ""
            } ${
              location.pathname.startsWith("/webmaster/therapists") ? "active" : ""
            }`}
          >
            <div className="submenu-toggle" onClick={() => toggleSubmenu("therapists")}>
              <img
                src={
                  location.pathname.startsWith("/webmaster/therapists") || openSubmenu === "therapists"
                    ? usersActive
                    : usersInactive
                }
                alt="terapeuți"
              />
              <>
                <span className="text">Terapeuți</span>
                <img
                  src={
                    location.pathname.startsWith("/webmaster/therapists") || openSubmenu === "therapists"
                      ? arrowUp
                      : arrowDown
                  }
                  alt="arrow"
                  className={`arrow-icon ${openSubmenu === "therapists" ? "rotated" : ""}`}
                />
              </>
            </div>
            {openSubmenu === "therapists" && (
              <ul className="submenu">
                <li className={location.pathname === "/webmaster/therapists" ? "active-sub" : ""}>
                  <Link to="/webmaster/therapists">Echipă</Link>
                </li>
                <li className={location.pathname === "/webmaster/therapists/appointments" ? "active-sub" : ""}>
                  <Link to="/webmaster/therapists/appointments">Programări</Link>
                </li>
                <li className={location.pathname === "/webmaster/therapists/scores" ? "active-sub" : ""}>
                  <Link to="/webmaster/therapists/scores">Punctaje</Link>
                </li>
                <li className={location.pathname === "/webmaster/therapists/medic-scores" ? "active-sub" : ""}>
                  <Link to="/webmaster/therapists/medic-scores">Acoperire orară medici</Link>
                </li>
                <li className={location.pathname === "/webmaster/therapists/points" ? "active-sub" : ""}>
                  <Link to="/webmaster/therapists/points">Puncte Bonusuri</Link>
                </li>
              </ul>
            )}
          </li>
        )}

        {/* Medici (fără submeniu) */}
        <li className={location.pathname.startsWith("/webmaster/medics") ? "medics active" : ""}>
          <Link to="/webmaster/medics">
            <img
              src={
                location.pathname.startsWith("/webmaster/medics")
                  ? medicIcon
                  : medicIcon
              }
              alt="medici"
            />
            {!isCollapsed && <span className="text">Medici</span>}
          </Link>
        </li>

        {/* Pacienți (fără submeniu) */}
        <li className={location.pathname.startsWith("/webmaster/patients") ? "patients active" : ""}>
          <Link to="/webmaster/patients">
            <img
              src={
                location.pathname.startsWith("/webmaster/patients")
                  ? usersActive
                  : usersInactive
              }
              alt="pacienți"
            />
            {!isCollapsed && <span className="text">Pacienți</span>}
          </Link>
        </li>
                {/* Pacienți (fără submeniu) */}
        <li className={location.pathname.startsWith("/webmaster/patient-appointments") ? "patient-app active" : ""}>
          <Link to="/webmaster/patient-appointments">
            <img
              src={
                location.pathname.startsWith("/webmaster/patient-appointments")
                  ? appointmentsIcon
                  : appointmentsIcon
              }
              alt="pacienți"
            />
            {!isCollapsed && <span className="text">Programări pacienți</span>}
          </Link>
        </li>
      </ul>
      <button className="logout" onClick={handleLogout}>
        <img src={logoutIcon} alt="Logout" />
        {!isCollapsed && <span className="text">Logout</span>}
      </button>
    </div>
  );
};

export default WebmasterSidebar;
